import React from 'react';
import LoadingScreen from './LoadingScreen';
import { isIOS, isAndroid, isNative } from '../utils/platformUtils';

const AuthLoadingScreen = ({ 
  message = 'Initializing authentication...',
  className = '',
  style = {}
}) => {
  const isNativePlatform = isNative();
  
  // Platform-specific auth loading styles
  const getAuthContainerStyles = () => {
    const baseStyles = {
      ...style
    };

    if (isNativePlatform) {
      return {
        ...baseStyles,
        // Add subtle gradient for auth loading
        background: isIOS() 
          ? 'linear-gradient(135deg, #F2F2F7 0%, #E5E5EA 100%)'
          : isAndroid() 
          ? 'linear-gradient(135deg, #FAFAFA 0%, #F5F5F5 100%)'
          : 'linear-gradient(135deg, #FFFFFF 0%, #F8F9FA 100%)'
      };
    }

    return {
      ...baseStyles,
      background: 'linear-gradient(135deg, #FFFFFF 0%, #F8F9FA 100%)'
    };
  };

  // Platform-specific auth loading message
  const getAuthMessage = () => {
    if (message !== 'Initializing authentication...') {
      return message;
    }

    if (isNativePlatform) {
      return isIOS() 
        ? 'Setting up your account...'
        : isAndroid() 
        ? 'Preparing your workspace...'
        : 'Initializing authentication...';
    }

    return 'Initializing authentication...';
  };

  return (
    <LoadingScreen
      message={getAuthMessage()}
      showSpinner={true}
      size="large"
      variant="fullscreen"
      className={`auth-loading-screen ${className}`}
      style={getAuthContainerStyles()}
    />
  );
};

export default AuthLoadingScreen; 